import { useTranslation } from '@utils/i18n/i18n';

function ChallengesAndSolutions() {
  const { t } = useTranslation();

  return (
    <>
      <p>
        {t('The main challenge for the Pagasitikos Gulf is to understand whether the coastal ecosystem can recover from the severe disturbance caused by the September 2023 floods, or whether it may shift towards a new, degraded ecological state. Floodwaters transported sediments, organic matter, debris, agrochemicals, fertilisers, pathogens and residues from damaged infrastructure into the Gulf, affecting water colour, turbidity, bathing-water quality and the wider marine food web. These pressures raise concerns for aquatic life, fisheries, seafood safety, biodiversity, antimicrobial resistance and potential zoonotic disease pathways.')}
      </p>
      <p>
        {t('ENHANCE addresses these challenges by combining satellite Earth Observation, in-situ sampling and One Health indicators into an integrated monitoring and decision-support approach. The case study will assess land-based pressures, eutrophication risk, chlorophyll-a, harmful algal bloom conditions, nutrients, pathogens, alien species, biodiversity loss, bathing-water quality and food-security risks. Monthly field measurements, fish-tissue analyses and satellite-derived products will support the development of dynamic risk maps for human, animal and environmental health. The solution also includes close collaboration with local stakeholders, including regional authorities, public health and agriculture services, fisheries, civil protection actors and coastal users. ')}
      </p>
      <p>
        {t('Through the ENHANCE dashboard, these data will be translated into accessible information to support early warning, ecosystem recovery assessment, evidence-based coastal management and climate-resilient decision-making for the Pagasitikos Gulf.')}
      </p>
    </>
  );
}

const LOCATIONS = [
  {
    id: 'pagasitikos-gulf',
    label: 'Pagasitikos Gulf',
    coordinates: [23.00910584018645, 39.222059961347043],
    aboutParagraphs: [
      'The Pagasitikos Gulf is located in central Greece, in the Region of Thessaly, with the city of Volos at its northern edge and an opening to the Aegean Sea to the south. Surrounded by the Pelion peninsula, it is a highly valued coastal area for tourism, recreation, fisheries and local communities.',
      'The Gulf is closely connected to the Thessaly plain, one of Greece\'s most important agricultural and livestock-producing regions. Following the extreme flooding events of September 2023, large volumes of freshwater, sediments, debris, agrochemicals, nutrients and microbial contaminants were transported from inland areas into the marine environment.',
      'This case study focuses on the recovery of the Pagasitikos Gulf after the floods, assessing how environmental pressures affect water quality, marine ecosystems, seafood safety and public health through a One Health perspective.',
    ],
    challengesTitle: 'Challenges & solutions',
    challengesText: <ChallengesAndSolutions />,
    imageAlt: 'Pagasitikos Gulf challenges and solutions',
    imagePath: '/img/misc/pagasitikos-gulf.png',
  },
];

const LOCATION = LOCATIONS[0];

export { LOCATIONS, LOCATION };
